export interface WishlistSummary {
  id: number
  name: string
  description: string | null
  items_count: number
  location_ids: number[]
}

function csrfToken(): string {
  const el = document.querySelector('meta[name="csrf-token"]')
  return el?.getAttribute('content') || ''
}

async function call<T>(method: string, url: string, body?: unknown): Promise<T | null> {
  try {
    const res = await fetch(url, {
      method,
      headers: {
        'X-CSRF-Token': csrfToken(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: body ? JSON.stringify(body) : undefined,
    })
    if (!res.ok) return null
    if (res.status === 204) return null
    return (await res.json()) as T
  } catch {
    return null
  }
}

export async function listWishlists(): Promise<WishlistSummary[]> {
  const data = await call<{ wishlists: WishlistSummary[] }>('GET', '/api/v1/wishlists')
  return data?.wishlists ?? []
}

export async function createWishlist(name: string, description?: string): Promise<WishlistSummary | null> {
  const data = await call<{ wishlist: WishlistSummary }>('POST', '/api/v1/wishlists', {
    wishlist: { name, description },
  })
  return data?.wishlist ?? null
}

export async function updateWishlist(id: number, name: string, description?: string): Promise<WishlistSummary | null> {
  const data = await call<{ wishlist: WishlistSummary }>('PATCH', `/api/v1/wishlists/${id}`, {
    wishlist: { name, description },
  })
  return data?.wishlist ?? null
}

export async function deleteWishlist(id: number): Promise<boolean> {
  const res = await fetch(`/api/v1/wishlists/${id}`, {
    method: 'DELETE',
    headers: { 'X-CSRF-Token': csrfToken(), Accept: 'application/json' },
    credentials: 'same-origin',
  })
  return res.ok
}

export async function addLocationToWishlist(wishlistId: number, locationId: number): Promise<WishlistSummary | null> {
  const data = await call<{ wishlist: WishlistSummary }>(
    'POST',
    `/api/v1/wishlists/${wishlistId}/items`,
    { location_id: locationId },
  )
  return data?.wishlist ?? null
}

export async function removeLocationFromWishlist(wishlistId: number, locationId: number): Promise<WishlistSummary | null> {
  const data = await call<{ wishlist: WishlistSummary }>(
    'DELETE',
    `/api/v1/wishlists/${wishlistId}/items/${locationId}`,
  )
  return data?.wishlist ?? null
}
